var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.003 13.705a.915.915 0 0 0-.916.908V16a1.18 1.18 0 0 1-1.177 1.177H4.09A1.18 1.18 0 0 1 2.913 16v-1.387a.915.915 0 0 0-1.823 0V16a3 3 0 0 0 3 3h11.82a3 3 0 0 0 3-3v-1.387a.907.907 0 0 0-.907-.908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M10 1a1.455 1.455 0 0 0-1.455 1.455V9.25a.187.187 0 0 1-.188.188H6.364a.75.75 0 0 0-.548 1.2l3.638 4.184a.75.75 0 0 0 1.095 0l3.637-4.184a.75.75 0 0 0-.548-1.2h-1.995a.19.19 0 0 1-.187-.188V2.455A1.455 1.455 0 0 0 10 1"
  })));
};
export { SvgDownloadIcon as ReactComponent };